import { isDark, me } from './selectors.js';
import { go, render } from './shell.js';
import { S, UI, save } from './store.js';
import { closeModal } from './ui.js';
import { MODULES } from '../modules/index.js';

export const actions={
nav(el){if(el.dataset.s)UI.stab=el.dataset.s;go(el.dataset.v)},
navtoggle(){UI.nav=UI.nav?0:1;render()},
navclose(){UI.nav=0;render()},
theme(){S.theme=isDark()?'light':'dark';save();render()},
mclose(){closeModal()}
};

export const changes={
setme(el){
  S.me=el.value;UI.rtab=null;const u=me();
  if(!u.dept.includes(UI.dept))UI.dept=u.dept[0];
  const m=MODULES.find(x=>x.id===UI.v||(x.views&&x.views[UI.v]));
  if(m&&m.show&&!m.show(u))UI.v='today';
  save();render();
}
};
